var map = {
	"./logo-1.svg": 15,
	"./logo-2.svg": 988,
	"./logo-3.svg": 933,
	"./logo-4.svg": 362,
	"./logo-5.svg": 883,
	"./logo-6.svg": 128,
	"./logo-7.svg": 81,
	"./logo-8.svg": 926,
	"./logo-9.svg": 959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 285;